import { confirmModalOverrides } from '../AdditionalSales/styled-components'

const useShellConfirmModal = (closeable: boolean, onCancel: () => void) => {
  const close = () => {
    if (closeable) onCancel()
  }

  return { close, modalOverrides: confirmModalOverrides }
}

export default useShellConfirmModal
